import { ComponentPropsWithoutRef, useCallback, useState } from 'react';

import WaveUINotificationBar from '../components/utilities/WaveUINotificationBar';

type NotificationBar = Omit<
  ComponentPropsWithoutRef<typeof WaveUINotificationBar>,
  'close'
>;

const useNotificationBar = () => {
  const [notificationBar, setNotificationBar] = useState<NotificationBar>({
    open: false,
    message: '',
    severity: 'success',
  });

  const onUpdateNotificationBar = useCallback(
    (state: Partial<NotificationBar>) => {
      setNotificationBar((prev) => ({
        ...prev,
        ...state,
      }));
    },
    [setNotificationBar],
  );

  return { notificationBar, onUpdateNotificationBar };
};

export default useNotificationBar;
